import { queryOptions, skipToken } from "@tanstack/react-query";

import { MASTER_INVALIDATION_KEY } from "@/api/queryClient";
import { getPaginatedServiceJobs, getServiceJob, getServiceJobsByIds } from "@/api/resources/serviceJobs/api";
import i18n from "@/providers/i18n";
import { type QueryPaginationFilters } from "@/utils/pagination";

import type { PaginatedServiceJobsProps, ServiceJobDetailCorrected, ServiceJobDetailExtendedCorrected } from "./types";

const entity = i18n.t("service-job");
const entityErrorMessage = {
  text: i18n.t("notify.error-reason.unexpected"),
  title: i18n.t("notify.get.error", { e: entity }),
};
const entities = i18n.t("service-jobs");
const entitiesErrorMessage = {
  text: i18n.t("notify.error-reason.unexpected"),
  title: i18n.t("notify.get.error", { e: entities }),
};

export const serviceJobsQueryKeys = {
  all: () => [...MASTER_INVALIDATION_KEY, "serviceJobs"],
  lists: () => [...serviceJobsQueryKeys.all(), "list"],
  listByIds: (ids?: string[]) => [...serviceJobsQueryKeys.lists(), "byIds", ids],
  listPaginated: (queryKeyPaginationFilters: QueryPaginationFilters) => [
    ...serviceJobsQueryKeys.lists(),
    "paginated",
    queryKeyPaginationFilters,
  ],
  byId: (id?: string) => [...serviceJobsQueryKeys.all(), "byId", id],
};

export const serviceJobsQueries = {
  listByIds: (ids?: string[]) =>
    queryOptions({
      queryKey: [...serviceJobsQueryKeys.listByIds(ids)],
      queryFn: () =>
        getServiceJobsByIds({
          keyIn: "ids",
          idsIn: ids,
        }) as Promise<ServiceJobDetailCorrected[]>,
      meta: {
        errorMessage: entitiesErrorMessage,
      },
    }),
  listPaginated: (queryKeyPaginationFilters: PaginatedServiceJobsProps) =>
    queryOptions({
      queryKey: [...serviceJobsQueryKeys.listPaginated(queryKeyPaginationFilters)],
      queryFn: () => getPaginatedServiceJobs(queryKeyPaginationFilters),

      meta: {
        errorMessage: entitiesErrorMessage,
      },
    }),
  byId: (id?: string) =>
    queryOptions({
      queryKey: [...serviceJobsQueryKeys.byId(id)],
      queryFn: id ? () => getServiceJob({ _id: id }) as Promise<ServiceJobDetailExtendedCorrected | null> : skipToken,

      meta: {
        errorMessage: entityErrorMessage,
      },
    }),
};
